import { seedConfigFromSample } from "../../../../Routes/RenderPdf/seedConfig";
import { trendSampleData } from "../../../../Routes/RenderPdf/trendSampleData";

export function initReportData(state, payload) {
  const reportType = (payload && payload.reportType) || "standard";
  const next = {
    editable: !!(payload && payload.editable),

    reportType,
    isProcessing: !!(payload && payload.editable),
    dirty: false,
    trendDirty: false,
    saving: false,
    error: null,
  };

  return next;
}
